import React, { Component } from 'react';
import { Container, Row, Col, Card, CardBody, CardHeader, Form, FormGroup, Label, Input, Button, Alert } from 'reactstrap';

export class Register extends Component {
  static displayName = Register.name;

  constructor(props) {
    super(props);
    this.state = {
      formData: {
        username: '',
        email: '',
        password: '',
        confirmPassword: '',
        firstName: '',
        lastName: ''
      },
      errors: {},
      loading: false,
      success: false,
      errorMessage: ''
    };
  }

  handleInputChange = (event) => {
    const { name, value } = event.target;
    this.setState({
      formData: {
        ...this.state.formData,
        [name]: value
      },
      errors: {
        ...this.state.errors,
        [name]: ''
      }
    });
  };

  validateForm = () => {
    const { formData } = this.state;
    const errors = {};

    // Username validation
    if (!formData.username.trim()) {
      errors.username = 'Имя пользователя обязательно';
    } else if (formData.username.length < 3) {
      errors.username = 'Имя пользователя должно содержать минимум 3 символа';
    }

    // Email validation
    if (!formData.email.trim()) {
      errors.email = 'Email обязателен';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      errors.email = 'Неверный формат email';
    }

    // Password validation
    if (!formData.password) {
      errors.password = 'Пароль обязателен';
    } else if (formData.password.length < 6) {
      errors.password = 'Пароль должен содержать минимум 6 символов';
    }

    // Confirm password validation
    if (!formData.confirmPassword) {
      errors.confirmPassword = 'Подтверждение пароля обязательно';
    } else if (formData.password !== formData.confirmPassword) {
      errors.confirmPassword = 'Пароли не совпадают';
    }

    this.setState({ errors });
    return Object.keys(errors).length === 0;
  };

  handleSubmit = async (event) => {
    event.preventDefault();
    
    if (!this.validateForm()) {
      return;
    }

    this.setState({ loading: true, errorMessage: '' });

    try {
      const response = await fetch('/api/auth/register', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(this.state.formData),
      });

      if (response.ok) {
        this.setState({ 
          success: true, 
          loading: false,
          formData: {
            username: '',
            email: '',
            password: '',
            confirmPassword: '',
            firstName: '',
            lastName: ''
          }
        });
      } else {
        const errorData = await response.json();
        this.setState({
          errorMessage: errorData.message || 'Ошибка регистрации',
          loading: false
        });
      }
    } catch (error) {
      this.setState({
        errorMessage: 'Ошибка сети. Попробуйте еще раз.',
        loading: false
      });
    }
  };

  render() {
    const { formData, errors, loading, success, errorMessage } = this.state;

    if (success) {
      return (
        <Container className="mt-5">
          <Row className="justify-content-center">
            <Col md="6">
              <Alert color="success">
                <h4>Регистрация успешна!</h4>
                <p>Ваш аккаунт был успешно создан, но пока неактивен. Обратитесь к администратору для активации.</p>
                <Button color="primary" href="/login">Войти в систему</Button>
              </Alert>
            </Col>
          </Row>
        </Container>
      );
    }

    return (
      <Container className="mt-5">
        <Row className="justify-content-center">
          <Col md="6">
            <Card>
              <CardHeader>
                <h3 className="mb-0">Регистрация</h3>
              </CardHeader>
              <CardBody>
                {errorMessage && (
                  <Alert color="danger">
                    {errorMessage}
                  </Alert>
                )}
                
                <Form onSubmit={this.handleSubmit} className="register-form">
                  <FormGroup>
                    <Label for="username">Имя пользователя *</Label>
                    <Input
                      type="text"
                      name="username"
                      id="username"
                      value={formData.username}
                      onChange={this.handleInputChange}
                      invalid={!!errors.username}
                      placeholder="Введите имя пользователя"
                    />
                    {errors.username && <div className="invalid-feedback">{errors.username}</div>}
                  </FormGroup>

                  <FormGroup>
                    <Label for="email">Email *</Label>
                    <Input
                      type="email"
                      name="email"
                      id="email"
                      value={formData.email}
                      onChange={this.handleInputChange}
                      invalid={!!errors.email}
                      placeholder="Введите email"
                    />
                    {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                  </FormGroup>

                  <Row>
                    <Col md="6">
                      <FormGroup>
                        <Label for="firstName">Имя</Label>
                        <Input
                          type="text"
                          name="firstName"
                          id="firstName"
                          value={formData.firstName}
                          onChange={this.handleInputChange}
                          placeholder="Введите имя"
                        />
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup>
                        <Label for="lastName">Фамилия</Label>
                        <Input
                          type="text"
                          name="lastName"
                          id="lastName"
                          value={formData.lastName}
                          onChange={this.handleInputChange}
                          placeholder="Введите фамилию"
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <FormGroup>
                    <Label for="password">Пароль *</Label>
                    <Input
                      type="password"
                      name="password"
                      id="password"
                      value={formData.password}
                      onChange={this.handleInputChange}
                      invalid={!!errors.password}
                      placeholder="Введите пароль"
                    />
                    {errors.password && <div className="invalid-feedback">{errors.password}</div>}
                  </FormGroup>

                  <FormGroup>
                    <Label for="confirmPassword">Подтверждение пароля *</Label>
                    <Input
                      type="password"
                      name="confirmPassword"
                      id="confirmPassword"
                      value={formData.confirmPassword}
                      onChange={this.handleInputChange}
                      invalid={!!errors.confirmPassword}
                      placeholder="Подтвердите пароль"
                    />
                    {errors.confirmPassword && <div className="invalid-feedback">{errors.confirmPassword}</div>}
                  </FormGroup>

                  <FormGroup className="text-center">
                    <Button 
                      type="submit" 
                      color="primary" 
                      size="lg" 
                      disabled={loading}
                      block
                    >
                      {loading ? 'Регистрация...' : 'Зарегистрироваться'}
                    </Button>
                  </FormGroup>

                  <div className="text-center">
                    <p>Уже есть аккаунт? <a href="/login">Войти в систему</a></p>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }
}
